import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import {FilterProvider} from "../../pages/Marketplace/FilterContext";

const Layout = ({children}) => {
    return (
        <FilterProvider>
            <Header/>
            <main>{children}</main>
            <Footer/>
        </FilterProvider>
    );
};

export default Layout;
